import { render } from "./PaymentButton.vue?vue&type=template&id=276243db&scoped=true"
import script from "./PaymentButton.vue?vue&type=script&lang=js"
export * from "./PaymentButton.vue?vue&type=script&lang=js"

import "./PaymentButton.vue?vue&type=style&index=0&id=276243db&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-276243db"]])

export default __exports__